import { paymentAcceptUrl, paymentCancelUrl, netsPaymentAcceptUrl, netsPaymentCancelUrl, netsPaymentUrl } from '../resources.js'
import getRequest from '../commons/getRequest';

async function handleCheckoutCancel(orderid) {
    let url = `${paymentCancelUrl}/${orderid}`;
    try {
        return await getRequest.getData(url);
    }
    catch (err) {
        throw err;
    }
}

async function handleNetsCheckoutAccept(paymentId) {

    let url = `${netsPaymentAcceptUrl}/${paymentId}`;
    let data = null;
    try {
        await getRequest.getData(url)
                    .then( response => {
                        data = response
                    });
        return data;
    }
    
    catch (err) {
        throw err;
    }
}

async function handleNetsCheckoutAcceptRedirect(orderId) {

    let url = `${netsPaymentAcceptRedirectUrl}/${orderId}`;
    let data = null;
    try {
        await getRequest.getData(url)
                    .then( response => {
                        data = response
                    });
        return data;
    }
    
    catch (err) {
        throw err;
    }
}

async function handleNetsCheckoutCancel(paymentId) {
    let url = `${netsPaymentCancelUrl}/${paymentId}`;
    let data = null;
    try {
        await getRequest.getData(url)
                .then( response => {
                    data = response
                });
        return data;
    }
    catch (err) {
        throw err;
    }
}

async function getCartInfo(paymentId) {
    let url = `${netsPaymentUrl}/getCartInfoByPaymentIdAndOrderId/${paymentId}`;
    let data = null;
    try {
        await getRequest.getData(url)
                .then( response => {
                    data = response
                });
        return data;
    }
    catch (err) {
        throw err;
    }

}

async function getPaymentDetailById(paymentId) {
    //console.log('getPaymentDetailById ' + paymentId); 
    let url = `${netsPaymentUrl}/getPaymentDetailById/${paymentId}`;
    let data = null
    try {
        await getRequest.getData(url)
                .then( response => {
                    data = response
                });
            console.log(data)
        return data;
    }
    catch (err) {
        throw err;
    }

}



export default {
    handleNetsCheckoutAccept,
    handleNetsCheckoutCancel,
    handleCheckoutCancel,
    handleNetsCheckoutAcceptRedirect,
    getCartInfo,
    getPaymentDetailById
}

